export const variants = { SUCCESS: 'success', INFO: 'info', ERROR: 'error' };
